import type { Nullable } from '@src/shared/types/common';

function setCookie(name: string, value: string, maxAge: number) {
    document.cookie = `${name}=${value};max-age=${maxAge};path=/`;
}

function getCookie(name: string): Nullable<string> {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);

    return parts.length === 2 ? (parts.pop()?.split(';').shift() ?? null) : null;
}

function deleteCookie(name: string) {
    const date = new Date();

    /**
     * Set it expire in -1 days
     * */
    date.setTime(date.getTime() + (-1 * 24 * 60 * 60 * 1000));
    document.cookie = `${name}=; expires=${date.toUTCString()}; path=/`;
}

window.getCookie = getCookie;
window.setCookie = setCookie;
window.deleteCookie = deleteCookie;
